import withDraft from '@/utils/draftHelper';
import actions from '@/cohorts/constants';
import { updateAuditName } from './state';

const updateCohortName = withDraft((draft, { code, result: { name } }) => {
  updateAuditName(draft, 'cohort', code, name);
});

export default {
  [actions.EDIT_COHORT_SUCCESS]: updateCohortName,
};
